import React from "react";
import { Card, Grid, Typography, Box } from "@mui/material";

const summaryCardSx = {
  p: 3,
  minHeight: 120,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  borderRadius: "18px",
  border: "1px solid rgba(47,99,173,0.08)",
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
  backgroundColor: "rgba(255,255,255,0.96)",
};

const labelSx = {
  fontSize: "0.95rem",
  fontWeight: 600,
  color: "#6b778c",
  mb: 1,
};

const valueSx = {
  fontSize: { xs: "1.5rem", md: "1.9rem" },
  fontWeight: 800,
  color: "#223142",
  lineHeight: 1.2,
};

const helperSx = {
  fontSize: "0.8rem",
  color: "#8a94a6",
  mt: 0.75,
};

const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BillingSummaryCards = ({ data }) => {
  const totalBilled = data
    .filter((item) => item.billable)
    .reduce((sum, item) => sum + parseFloat(item.price || 0), 0);

  const uniqueWorkOrders = new Set();
  data.forEach((item) => {
    if (!item.billable) return;

    let key = null;
    if (item.work_order_id && item.billable_request_id) {
      key = `wo-${item.work_order_id}-br-${item.billable_request_id}`;
    } else if (item.work_order_id) {
      key = `wo-${item.work_order_id}`;
    } else if (item.violation_id) {
      key = `violation-${item.violation_id}`;
    } else if (item.architectural_request_id) {
      key = `arch-${item.architectural_request_id}`;
    } else if (item.general_request_id) {
      key = `gen-${item.general_request_id}`;
    }

    if (key) uniqueWorkOrders.add(key);
  });

  const billedWOCount = uniqueWorkOrders.size;
  const averagePerWO = billedWOCount > 0 ? totalBilled / billedWOCount : 0;

  const cards = [
    {
      title: "Total Billed Amount",
      value: formatCurrency(totalBilled),
      helper: "Sum of all billable exported records",
    },
    {
      title: "Work Orders Billed",
      value: billedWOCount.toLocaleString("en-US"),
      helper: "Unique billed work order records",
    },
    {
      title: "Avg $ per WO",
      value: formatCurrency(averagePerWO),
      helper: "Average billed amount per work order",
    },
  ];

  return (
    <Grid container spacing={2.5}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} key={card.title}>
          <Card sx={summaryCardSx}>
            <Box>
              <Typography sx={labelSx}>{card.title}</Typography>
              <Typography sx={valueSx}>{card.value}</Typography>
              <Typography sx={helperSx}>{card.helper}</Typography>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BillingSummaryCards;